import { Component, OnInit, Input, Inject } from "@angular/core";
import { Lesson } from "src/app/model/lesson.model";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import {  ReservationSubItem } from "src/app/model/reservation.model";
import { LessonService } from "src/app/service/lesson.service";

@Component({
  selector: "app-lesson-detail",
  templateUrl: "./lesson-detail.component.html",
  styleUrls: ["./lesson-detail.component.css"]
})
export class LessonDetailComponent implements OnInit {
  lesson: Lesson;
  item: ReservationSubItem;
  trik = true;

  constructor(
    public dialogRef: MatDialogRef<LessonDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LessonDetailDialogData,
    private lessonService: LessonService
  ) {}

  ngOnInit() {
    this.lesson = this.data.selectedLesson;
    this.item = this.data.selectedReservationItem;
  }

  onCancel(): void {
    this.dialogRef.close(this.item);
  }

  onConfirm(): void {
    this.dialogRef.close(this.item);
  }

  onAdd() {
    if (!this.lesson.students.find(x => x.id == this.item.id)) {
      this.lessonService
        .addStudent(this.lesson.id, this.item)
        .subscribe(data => {
          if (data) {
            this.lesson.students.push(this.item);
            this.item = null;
            this.dialogRef.close(this.item);
          }
        });
    }
  }
}

export interface LessonDetailDialogData {
  selectedLesson: Lesson;
  selectedReservationItem: ReservationSubItem;
}
